import { useMutation } from '@tanstack/react-query';
import { useMixpanel } from 'react-mixpanel-browser';

import { PostDisplayPreferencesPayload, PostDisplayPreferencesResponse } from '@/api/userAccount/types';
import { axios } from '@/common/axios';
import { MutationConfig, queryClient } from '@/common/react-query';

export const postDisplayPreferences = (
    payload: PostDisplayPreferencesPayload
): Promise<PostDisplayPreferencesResponse> => {
    return axios.post('/profile/save-display-preferences', payload);
};

type UsePostDisplayPreferencesOptions = {
    config?: MutationConfig<typeof postDisplayPreferences>;
    data?: PostDisplayPreferencesPayload;
};

export const usePostDisplayPreferences = ({ config }: UsePostDisplayPreferencesOptions = {}) => {
    const mixpanel = useMixpanel();
    return useMutation({
        // serialize display preference posts since we assemble the new object from the last known
        scope: { id: 'display-preferences' },
        ...config,
        mutationFn: postDisplayPreferences,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['display-preferences'] });
            queryClient.invalidateQueries({ queryKey: ['user-account'] });
            mixpanel?.track('User Display Preferences Updated');
        },
    });
};
